import React, { Component } from "react";
import image from "../../logo.png";
import "./Register.css";
import Connection from "../../classes/Connection.js";
import withRouter from "../withRouter/withRouter";
import { Navigate } from "react-router-dom";


class Register extends Component {
    state = { navigate: null };

    constructor(props) {
        super(props);
        this.refrencePage = props.router.params["*"];
        this.unRef = React.createRef();
        this.passwordRef = React.createRef();
    }

    logIn() {
        let un = this.unRef.current.value;
        let password = this.passwordRef.current.value;
        new Connection()
            .login(un, password)
            .then((res) => {
                let { token, un } = res.data;
                localStorage.setItem("admin_token", token);
                localStorage.setItem("un", un);
                this.setState({
                    navigate: (
                        <Navigate
                            to={
                                "/" +
                                (this.refrencePage ? this.refrencePage : "")
                            }
                        />
                    ),
                });
            })
            .catch((err) => {
                alert("نام کاربری و رمز عبور اشتباه است.");
            });
    }

    render() {
        return (
            <section className="h-100 gradient-form RegisterComponent">
                {this.state.navigate}
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-xl-10">
                            <div className="card rounded-3 text-black">
                                <div className="row g-0">
                                    <div className="col-lg-6 d-flex align-items-center gradient-custom-2">
                                        <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                                            <h4 className="mb-4">
                                                مدیریت فروشگاه اینترنتی نیکا{" "}
                                            </h4>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="card-body p-md-5 mx-md-4">
                                            <div className="text-center">
                                                <img
                                                    src={image}
                                                    className="logo"
                                                />
                                                <h3 className="mt-1 mb-5 pb-1">
                                                    خرازی اینترنتی نیکا
                                                </h3>
                                            </div>

                                            <form>
                                                <div className="form-outline mb-4">
                                                    <label
                                                        className="form-label"
                                                        htmlFor="un"
                                                    >
                                                        نام کاربری
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="user name"
                                                        name="user name"
                                                        className="form-control"
                                                        placeholder="نام کاربری"
                                                        ref={this.unRef}
                                                    />
                                                </div>

                                                <div className="form-outline mb-4">
                                                    <label
                                                        className="form-label"
                                                        htmlFor="password"
                                                    >
                                                        رمز عبور
                                                    </label>
                                                    <input
                                                        type="password"
                                                        id="password"
                                                        className="form-control"
                                                        placeholder="رمز عبور "
                                                        ref={this.passwordRef}
                                                    />
                                                </div>

                                                <div className="text-center pt-1 mb-5 pb-1">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-primary login"
                                                        id="login"
                                                        onClick={(e) =>
                                                            this.logIn()
                                                        }
                                                    >
                                                        وارد شدن
                                                    </button>
                                                    <br />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(Register);
